import React from "react";
import {
  Grid,
  TextField,
  IconButton,
  Button,
} from "@mui/material";
import { FieldArray, Field } from "formik";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import LGAutocomplete from "../../atoms/Common/LGAutocomplete.tsx";
import LGItemCellHeader from "../../atoms/Common/LGItemCellHeader";
import { getFinishedGoodList } from "../../api/finishedGoods";

const emptyDetail = () => ({
  finishedGoodId: "",
  finishedGood: null,
  workOrder: "",
  code: 0,
  quantity: 0,
  unitPrice: 0,
  pallets: 0,
  remains: 0,
});

const CPODetails = ({ companyId }) => {
  return (
    <Grid container rowSpacing={0} columnSpacing={0}>
      <Grid item xs={2.5}>
        <LGItemCellHeader label="Producto terminado" />
      </Grid>
      <Grid item xs={1.5}>
        <LGItemCellHeader label="Orden de trabajo" />
      </Grid>
      <Grid item xs={1}>
        <LGItemCellHeader label="Clave" />
      </Grid>
      <Grid item xs={1.5}>
        <LGItemCellHeader label="Cantidad" />
      </Grid>
      <Grid item xs={1.5}>
        <LGItemCellHeader label="Precio unitario" />
      </Grid>
      <Grid item xs={1.5}>
        <LGItemCellHeader label="Pallets" />
      </Grid>
      <Grid item xs={1.5}>
        <LGItemCellHeader label="Remanente" />
      </Grid>
      <Grid item xs={1}>
        <LGItemCellHeader label="Eliminar" color="error.main" />
      </Grid>

      <FieldArray name="details">
        {({ push, remove, form }) => (
          <>
            {(form.values.details || []).map((detail, index) => (
              <Grid item xs={12} key={detail.id ?? `new-${index}`}>
                <Grid container spacing={0}>
                  <Grid item xs={2.5}>
                    <LGAutocomplete
                      id={`details.${index}.finishedGoodId`}
                      name={`details.${index}.finishedGoodId`}
                      label=""
                      fetchFunction={getFinishedGoodList}
                      fetchBy="search"
                      queryParams={{ companyId, pageSize: 1000 }}
                      optionLabel={["code", "name"]}
                      optionSeparator=" | "
                      value={detail.finishedGood || null}
                      size="small"
                      margin="none"
                      onChange={(_event, value) => {
                        form.setFieldValue(
                          `details.${index}.finishedGoodId`,
                          value?.id || ""
                        );
                        form.setFieldValue(
                          `details.${index}.finishedGood`,
                          value || null
                        );
                        if (value?.unitPrice != null) {
                          form.setFieldValue(
                            `details.${index}.unitPrice`,
                            value.unitPrice
                          );
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={1.5}>
                    <Field
                      name={`details.${index}.workOrder`}
                      as={TextField}
                      type="text"
                      size="small"
                      margin="none"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Field
                      name={`details.${index}.code`}
                      as={TextField}
                      type="text"
                      size="small"
                      margin="none"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={1.5}>
                    <Field
                      name={`details.${index}.quantity`}
                      as={TextField}
                      type="number"
                      size="small"
                      margin="none"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={1.5}>
                    <Field
                      name={`details.${index}.unitPrice`}
                      as={TextField}
                      type="number"
                      size="small"
                      margin="none"
                      fullWidth
                      inputProps={{ step: "any" }}
                    />
                  </Grid>
                  <Grid item xs={1.5}>
                    <Field
                      name={`details.${index}.pallets`}
                      as={TextField}
                      type="number"
                      size="small"
                      margin="none"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={1.5}>
                    <Field
                      name={`details.${index}.remains`}
                      as={TextField}
                      type="number"
                      size="small"
                      margin="none"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <IconButton
                      color="error"
                      onClick={() => remove(index)}
                      disabled={(form.values.details || []).length <= 1}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
            ))}
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                color="secondary"
                startIcon={<AddIcon />}
                onClick={() => push(emptyDetail())}
              >
                Agregar línea
              </Button>
            </Grid>
          </>
        )}
      </FieldArray>
    </Grid>
  );
};

export default CPODetails;
export { emptyDetail };
